import book from '../../../../../router/book';

export const navbar = [
  {
    title: 'header_for_advertisers',
    link: book.advertisers,
  },
  {
    title: 'header_for_bloggers',
    link: book.bloggers,
  },
  {
    title: 'header_for_referrals',
    link: book.referrals,
  },
  {
    title: 'header_for_blog',
    link: book.blog,
  },
];
